/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiConversionTypeFromJSON, ApiConversionTypeToJSON, } from './ApiConversionType';
import { ApiReservedConversionFromJSON, ApiReservedConversionToJSON, } from './ApiReservedConversion';
export function ApiConversionInputFromJSON(json) {
    return ApiConversionInputFromJSONTyped(json, false);
}
export function ApiConversionInputFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !exists(json, 'name') ? undefined : json['name'],
        'pushToMeta': !exists(json, 'pushToMeta') ? undefined : json['pushToMeta'],
        'reserved': !exists(json, 'reserved') ? undefined : ApiReservedConversionFromJSON(json['reserved']),
        'type': !exists(json, 'type') ? undefined : ApiConversionTypeFromJSON(json['type']),
    };
}
export function ApiConversionInputToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'pushToMeta': value.pushToMeta,
        'reserved': ApiReservedConversionToJSON(value.reserved),
        'type': ApiConversionTypeToJSON(value.type),
    };
}
